// extracted by mini-css-extract-plugin
module.exports = {"title":"Inclusion_title__1Gy0X"};